// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a bhj_ji","CommentListPlaceholder--Legacy":"ih_b bhj_ra bhj_wo"};